'use client';
import Image from 'next/image';
import { ReactNode, useState } from 'react';

export const Card = ({
  icon,
  heading,
  description,
  className,
  value,
  children,
}: {
  icon: string;
  heading: string;
  description: string;
  className?: string;
  value?: string;
  children: ReactNode;
}) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className={`${className} p-4 rounded-[1rem] shadow-custom ${value && 'bg-gradient-to-r from-overlay-100/15 from-0% to-primary-200/15 to-100%'}`}
    >
      <div
        className={`flex justify-center gap-4 ${show ? 'items-start' : 'items-center'}`}
      >
        <Image
          src={value ? '/icons/check.svg' : icon}
          alt={heading}
          width={24}
          height={24}
          className={`${show && 'pt-6'}`}
        />
        <div className="flex flex-col gap-2">
          <div className="flex gap-2">
            <div className="flex flex-col">
              <span className="font-bold text-text-primary">{heading}</span>
              <span className="text-text-secondary">{description}</span>
            </div>
            <button onClick={() => setShow(!show)}>
              <Image
                src={`/icons/chevron_${show ? 'up' : 'down'}-gray.svg`}
                width={24}
                height={24}
                alt="Chevron Down"
              />
            </button>
          </div>
          {show && children}
        </div>
      </div>
    </div>
  );
};
